import { type TicketQuery } from '@/gql/myomr'
type Ticket = NonNullable<TicketQuery['ticket']>

export function isTicketRequest(ticket: Ticket) {
  return ticket.source === 'request_form' && ticket.aasmState === 'locked'
}
